// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9eeb08de","455":"a34923e2"}[chunkId] + ".chunk.js";
};